import axios from "axios"

const url = "/distributor/admin/api/v1/inventory/boxes"
export function getAllDealerBoxesListing (parameters) {
  return new Promise((resolve, reject) => {
    axios.post(url, {
      dealer: parameters.dealer,
      length: parameters.length,
      start: parameters.start,
      order: parameters.order,
      order_by: parameters.order_by,
      filter: {
        products: parameters.filter.products,
        search: parameters.filter.search,
        search_by: parameters.filter.search_by,
        created_at: parameters.filter.created_at,
        located_at: parameters.filter.located_at,
      }
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  })
}